export const SEARCH_SANDBOX_URLS = {
  'sb-1': 'https://sb1-search-api.snc-dev.aws.cinch.co.uk',
  'sb-2': 'https://sb2-search-api.snc-dev.aws.cinch.co.uk',
} as const

export type SearchSandbox = keyof typeof SEARCH_SANDBOX_URLS

const allowedStagesForSandboxes = new Set(['ephemeral', 'local'])

/**
 * Manual override for ephemeral and local preview builds only.
 * Set to 'sb-1' or 'sb-2' to point SEARCH_SERVICE_URL at that sandbox.
 * Set to null to use the stage URL.
 * Ignored when STAGE_NAME is development or production.
 */
export const EPHEMERAL_SEARCH_SANDBOX: SearchSandbox | null = null

export const resolveSearchServiceUrl = (
  stageName: string | undefined,
  sandbox: string | null,
  defaultUrl: string,
): string => {
  if (
    !stageName ||
    sandbox == null ||
    !allowedStagesForSandboxes.has(stageName)
  ) {
    return defaultUrl
  }

  const sandboxUrl = SEARCH_SANDBOX_URLS[sandbox as SearchSandbox]

  return sandboxUrl ?? defaultUrl
}
